/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedDetailPayments_user$ref: FragmentReference;
export type PdpSharedDetailPayments_user = {|
  +isVip: ?boolean,
  +isVerifiedTrade: ?boolean,
  +canSeeNetPrice: ?boolean,
  +canCheckoutWithCheck: ?boolean,
  +$refType: PdpSharedDetailPayments_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedDetailPayments_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVip",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "canSeeNetPrice",
      "name": "hasPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_NET_PRICE",
          "type": "String!"
        }
      ],
      "storageKey": "hasPermission(name:\"B_NET_PRICE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "canCheckoutWithCheck",
      "name": "hasPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_CHECKOUT_CHECK",
          "type": "String!"
        }
      ],
      "storageKey": "hasPermission(name:\"B_CHECKOUT_CHECK\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd476704e4d4c4ef0341516d97a2bafc8';
module.exports = node;
